import { DEVICE_PAIRING_VOCABULARIES } from './device-pairing.js';
/** Slice d561 of the catalog (D577): the vocabularies device pairing (D561) and the Admin's devices screen brought. */
export const SLICE_D561 = [...DEVICE_PAIRING_VOCABULARIES];
//# sourceMappingURL=slice-d561.js.map